import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import StaffForm from "./StaffForm";
import { editStaffApi, viewStaffApi } from "../../api/staffService";
import { getErrorMessage } from "../../utils/errorHandler";
const EditStaff = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const staffId = params?.staffId || location?.state?.staffId;
  const [staffData, setStaffData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    if (!staffId) {
      navigate("/staff");
      return;
    }
    const loadStaff = async () => {
      try {
        setPageLoading(true);
        const res = await viewStaffApi(staffId);
        setStaffData(res?.data || res);
      } catch (error) {
        setIsError(true);
        setMessage(getErrorMessage(error));
      } finally {
        setPageLoading(false);
      }
    };
    loadStaff();
  }, [staffId, navigate]);
  const handleUpdate = async (formData) => {
    try {
      setLoading(true);
      const payload = {
        staffId: staffId,
        ...formData,
      };
      const response = await editStaffApi(payload);
      if (response?.success === false) {
        setIsError(true);
        setMessage(response?.message || "Failed to update staff");
        return;
      }
      setIsError(false);
      setMessage(response?.message || "Staff updated successfully");
      setTimeout(() => {
        navigate("/staff");
      }, 1200);
    } catch (error) {
      setIsError(true);
      setMessage(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };
  if (pageLoading) {
    return (
      <div className="text-center mt-4">
        Loading staff details...
      </div>
    );
  }
  return (
    <div className="container mt-4">
      {message && (
        <div className={`alert ${isError ? "alert-danger" : "alert-success"}`}>
          {message}
        </div>
      )}
      <StaffForm
        initialData={{
          fullName: staffData?.fullName || "",
          gender: staffData?.gender || "MALE",
          email: staffData?.email || "",
          mobileCountryCode: staffData?.mobileCountryCode || "",
          role: staffData?.role || "STAFF",
          status: staffData?.status || "ACTIVE",
          clinics:
            typeof staffData?.clinics === "string"
              ? staffData.clinics
              : Array.isArray(staffData?.clinics) && staffData.clinics.length > 0
                ? staffData.clinics[0]._id || staffData.clinics[0] || ""
                : staffData?.clinics?._id || "",
        }}
        onSubmit={handleUpdate}
        loading={loading}
      />
    </div>
  );
};
export default EditStaff;
